import HARDCODE from '../../business-const/HardCode/HardCode'

import {
    formataValor
} from '../../business-components/Formata/Formata'



export const tipoDiagnosticoAposentadoriaChartList = ( values ) => {
    
    return [
        {
            id: HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual,
            descricao: 'Situação Atual',
            ordem: 10,
        },
        {
            id: HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoIdeal,
            descricao: 'Situação Ideal (Aporte mensal adicional de ' +
                formataValor(values.valorPresenteDeficitSimulacaoMensal, 2) + ')',
            ordem: 20,
        },
    ]
}

export default tipoDiagnosticoAposentadoriaChartList